import { render, staticRenderFns } from "./InputEmailTag.vue?vue&type=template&id=2c801f54&scoped=true&"
import script from "./InputEmailTag.vue?vue&type=script&lang=ts&"
export * from "./InputEmailTag.vue?vue&type=script&lang=ts&"
import style0 from "./InputEmailTag.vue?vue&type=style&index=0&id=2c801f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c801f54",
  null
  
)

export default component.exports